import BookIcon from '@material-ui/icons/Book'
import UserSellShow from './UserSellShow'
import UserSellList from './UserSellList'

export default {
  list: UserSellList,
  show: UserSellShow,
  icon: BookIcon,
}
